import { headerAlertClosed } from './header';

export function alert() {
  const hiddenClass = 'hidden';
  const alert = document.querySelector('.alert-block');

  function setSessionStorage(options={ display: true }) {
    const today = new Date();
    const data = Object.assign(options, { timestamp: today.setDate(today.getDate() + 1) });

    sessionStorage.setItem('alert', JSON.stringify(data));
  }

  function getSessionStorage() {
    if (!sessionStorage.getItem('alert')) {
      setSessionStorage();
    }

    return JSON.parse(sessionStorage.getItem('alert'));
  }

  function hideAlert() {
    alert.classList.add(hiddenClass);
    headerAlertClosed();
    setSessionStorage({ display: false });
  }

  if (alert) {
    const today = new Date();
    const currentTime = today.getTime();
    const sessionStorage = getSessionStorage();
    const closeButton = alert.querySelector('.close-button');

    if (!sessionStorage.display && sessionStorage.timestamp > currentTime) {
      hideAlert();
    } else if (closeButton) {
      closeButton.addEventListener('click', hideAlert);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/alerts.js